module.exports = __webpack_public_path__ + "media/coffee-preferences/equitable_trade_i_only_want_these-8054a24a.png";